import { createURLSearchParams } from '../../../utils/creator/createURLSearchParams.util';
import { customAxios } from '../../common/customAxios';

export const machinePriceStatisticsMetaApiUrl = '/machine-price-statistics/meta';

export interface IGetMachinePriceStatisticsMetaParams {
  brand?: string;
  minEngineOutputPs?: number;
  maxEngineOutputPs?: number;
  minMedianPrice?: number;
  maxMedianPrice?: number;
}

export interface IGetMachinePriceStatisticsMetaReturn {
  totalCount: number;
  brands: Array<{
    id: string;
    tractorCount: number;
  }>;
}

export const getMachinePriceStatisticsMeta = async ({
  searchParam,
}: {
  searchParam: IGetMachinePriceStatisticsMetaParams;
}): Promise<IGetMachinePriceStatisticsMetaReturn> => {
  const urlSearchParams = createURLSearchParams(searchParam);
  return customAxios.get(`${machinePriceStatisticsMetaApiUrl}?${urlSearchParams}`);
};
